import { FC, useEffect, useState } from "react";
import "./CheckoutCompleted.scss";
import MainNavbar from "../../components/MainNavbar/MainNavbar";
import { Card, Col, Container, Row } from "react-bootstrap";
import { BvIcon } from "bevi-icon";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useUsers } from "../../providers/Access/Users/UsersProvider";
import logo from "../../assets/img/bevi-ajuda-blue.svg";
import FormatMoney from "../../utils/FormatMoney";
import moment from "moment";

interface CheckoutCompletedProps {}

const CheckoutCompleted: FC<CheckoutCompletedProps> = () => {
  const [payments, setPayments] = useState<any>(null);

  const { handleListPaymentsMethods, isLoading, statusTutorial, setIsLoading } =
    useUsers();

  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const checkoutOk = localStorage.getItem("checkoutFinished") === "true";

    if (!id || isNaN(Number(id))) return;

    if (!checkoutOk) {
      navigate("/pricing/list", { replace: true });
      return;
    }

    let interval: NodeJS.Timeout;

    const fetchData = async () => {
      const ret = await handleListPaymentsMethods(Number(id));

      const hasValidData = ret.success && ret.data && ret.data.amount;

      if (hasValidData) {
        setPayments(ret.data);

        clearInterval(interval);

        setIsLoading(false);
      }
    };

    setIsLoading(true);

    fetchData();
    interval = setInterval(fetchData, 5000);

    return () => clearInterval(interval);
  }, [id]);

  const handleStart = () => {
    // Tutorial obrigatório desativado — sempre vai direto pro chat.
    // navigate(`${statusTutorial === 0 ? "/chats/tutorial" : "/chats/reply"}`);
    navigate("/chats/reply");
    localStorage.removeItem("checkoutOk");
    localStorage.removeItem("checkoutFinished");
    localStorage.removeItem("selectedPlan");
  };

  const handleBackMenu = () => {
    navigate("/home");
    localStorage.removeItem("checkoutOk");
    localStorage.removeItem("checkoutFinished");
    localStorage.removeItem("selectedPlan");
  };

  return (
    <>
      <MainNavbar />
      <div className="CheckoutCompleted" data-testid="CheckoutCompleted">
        {!isLoading ? (
          <Container>
            <Row>
              <Col md={12} className="d-flex justify-content-center mt-4">
                <Card className="card-confirmed">
                  <Card.Body>
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <BvIcon
                        name={`${payments ? "checkCircle" : "cancel"}`}
                        variant="solid"
                        width={128}
                        height={128}
                        style={{ color: "#787ABA" }}
                      />
                      <h1 className="mt-4">
                        {payments ? "Confirmado!" : "Falha no Pagamento!"}
                      </h1>
                      <h5 className="mt-4">
                        {payments
                          ? "O pagamento foi realizado com sucesso."
                          : "Ocorreu um erro ao revisar o seu pagamento."}
                      </h5>
                      {!payments && (
                        <span className="text-sm">
                          Verifique os dados e tente novamente
                        </span>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              {payments && (
                <Col md={12} className="d-flex justify-content-center mt-2">
                  <Card className="card-information text-center">
                    <Card.Body>
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="mt-3">
                          <h6>Valor pago</h6>
                          <span>{FormatMoney(payments?.amount)}</span>
                        </div>
                        <hr className="mt-3 mb-3" />
                        <div>
                          <h6>Data da transação</h6>
                          <span>
                            {moment(payments?.payment_date)
                              .locale("pt-br")
                              .format("DD MMM YYYY [às] HH:mm")}
                          </span>
                        </div>
                        <hr className="mt-3 mb-3" />
                        <div className="d-flex flex-column">
                          <h6>Para</h6>
                          <span>Bevicred Informações Cadastrais Ltda</span>
                          <span>CNPJ: 07.452.085/0001-98</span>
                        </div>
                        <hr className="mt-3 mb-3" />
                        <div>
                          <h6>Modo de pagamento</h6>
                          <span>
                            {payments?.card_type} - {payments?.card_brand}
                          </span>
                        </div>
                        <button
                          onClick={() => handleStart()}
                          className="mt-3 text-button"
                        >
                          Comece a usar
                        </button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              )}
              <Col md={12} className="d-flex justify-content-center mt-4 mb-4">
                <a onClick={() => handleBackMenu()}>Voltar ao menu inicial</a>
              </Col>
            </Row>
          </Container>
        ) : (
          <div className="loading-screen">
            <div className="loading-content">
              <img src={logo} alt="Logo" className="logo" />
              <div className="loader-bar" />
              <p className="loading-text">Carregando...</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CheckoutCompleted;
